import { render, staticRenderFns } from "./representatives-form.vue?vue&type=template&id=bba52870&"
import script from "./representatives-form.vue?vue&type=script&lang=js&"
export * from "./representatives-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports